import { jsx as _jsx } from "react/jsx-runtime";
import { ActivityComponent } from './Activity.component';
import { WellnessWrapper } from '../WellnessWrapper.component';
var Activity = function () {
    return (_jsx(WellnessWrapper, { children: _jsx(ActivityComponent, {}) }));
};
export default Activity;
